<template>
    <q-dialog
        :model-value="modelValue"
        position="right"
        @hide="$emit('hide')"
        @update:model-value="$emit('update:modelValue', $event)"
        maximized
    >
        <q-card class="tk-right-drawer" :style="{ width }">
            <header class="tk-right-drawer__header">
                <div>
                    <h2>{{ title }}</h2>
                    <p v-if="subtitle">{{ subtitle }}</p>
                </div>
                <q-btn
                    flat
                    round
                    dense
                    icon="close"
                    aria-label="Close"
                    @click="$emit('update:modelValue', false)"
                />
            </header>
            <q-separator />
            <div class="tk-right-drawer__content">
                <slot />
            </div>
        </q-card>
    </q-dialog>
</template>

<script>
export default {
    name: "TkRightDrawer",
    emits: ["hide", "update:modelValue"],
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.tk-right-drawer {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 14px 0 0 14px;
    background: #fff;
    box-shadow: -14px 0 36px rgba(47, 62, 70, 0.14);
    overflow: hidden;
}

.tk-right-drawer__header {
    display: flex;
    flex: 0 0 auto;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 20px 16px;
}

.tk-right-drawer__header h2 {
    margin: 0;
    color: #3d4b46;
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: 0.035em;
    line-height: 1.3;
}

.tk-right-drawer__header p {
    margin: 5px 0 0;
    color: #748078;
    font-size: 0.82rem;
    line-height: 1.4;
}

.tk-right-drawer__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.tk-right-drawer__content :deep(.q-card-actions) {
    position: sticky;
    bottom: 0;
    z-index: 1;
    padding: 12px 20px;
    border-top: 1px solid rgba(47, 62, 70, 0.09);
    background: rgba(255, 255, 255, 0.97);
}

@media (max-width: 700px) {
    .tk-right-drawer {
        width: 100vw !important;
        border-radius: 0;
    }

    .tk-right-drawer__header {
        padding: 14px 12px 12px;
    }
}
</style>
